var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show_modal)?_c('div',{staticClass:"fixed_modal"},[_c('div',{staticClass:"modal_content"},[_c('p',[_vm._v(_vm._s(_vm.message))]),_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }